import { useUserContext, IdentityProvider } from '@vp/ubik-context'

export const WithIdentityProvider = <P extends object>(Fragment: React.FC<P>) => {
  return (props: P) => {
    const userContext = useUserContext()

    return (
      <IdentityProvider auth={{ culture: userContext.locale }}>
        <Fragment {...props} />
      </IdentityProvider>
    )
  }
}
